import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

import img1 from "../../assets/img1.png";
import img2 from "../../assets/img2.webp";
import img3 from "../../assets/img3.png";

import img4 from "../../assets/img4.jpg";
import img5 from "../../assets/img5.jpg";
import img6 from "../../assets/img6.jpg";

const BlogPosts = ({}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  let lang = {lang: "gb"};

  // Fallback texts
  const fallbackTexts = {
    heading: {
      pl: 'NASZ BLOG',
      gb: 'Our blog',
      ru: 'НАШ БЛОГ'
    },
    closeButton: {
      pl: 'Zamknij',
      gb: 'Close',
      ru: 'Закрити'
    }
  };

  // Helper function to get the correct text based on language
  const getText = (key) => {
    return lang && lang.blog && lang.blog[key] 
      ? lang.blog[key] 
      : fallbackTexts[key][lang.lang] || fallbackTexts[key].gb;
  };

  const blogPosts = [
    {
      id: 1,
      img: img1,
      title: {
        pl: '',
        gb: 'The Journey to Confidence: How Onlyglance.com Helps Models Shine',
        ru: ''
      },
      description: {
        pl: '',
        gb: 'Sophia had always dreamed of modeling, but self-doubt held her back. Living in a small town, she thought opportunities like OnlyFans success were reserved for big-city influencers. One day, while scrolling online, she stumbled upon Onlyglance.com...',
        ru: ''
      },
      content: {
        pl: ``,
        gb: `<p><strong>Sophia’s Story:</strong></p><p>Sophia had always dreamed of modeling, but self-doubt held her back. Living in a small town, she thought opportunities like OnlyFans success were reserved for big-city influencers. One day, while scrolling online, she stumbled upon <strong>Onlyglance.com</strong>. Skeptical but curious, she filled out our contact form. That moment changed her life.</p><p><strong>Our Process:</strong></p><ul><li><strong>Professional Photoshoots:</strong> Our experienced female photographer made Sophia feel at ease, ensuring her photos were natural and striking.</li><li><strong>Content Strategy:</strong> Sophia learned how to showcase her authentic self while using proven strategies to grow her audience.</li><li><strong>Marketing Expertise:</strong> From choosing the right captions to leveraging hashtags, Sophia was guided every step of the way.</li></ul><p><strong>Sophia’s Success:</strong></p><p>Within three months, Sophia went from earning a few dollars to consistent five-figure months. More importantly, she gained the confidence to embrace her true self.</p><p><strong>Why Choose Us?</strong></p><p>At <strong>Onlyglance.com</strong>, we don’t just manage creators; we empower them. Our team of experts ensures every model feels supported, valued, and ready to succeed.</p><p>Ready to start your own journey to confidence and success? Join <strong>Onlyglance.com</strong> today and let’s create your success story together.</p>`,
        ru: ``
      }
    },
    {
        id: 2,
        img: img2,
        title: {
          pl: 'Za Obiektywem: Jeden Dzień z Życia Modelki OnlyFans',
          gb: 'Behind the Lens: A Day in the Life of an OnlyFans Model',
          ru: 'За кулисами: Один день из жизни модели OnlyFans'
        },
        description: {
          pl: 'Mia zaczyna dzień od dbania o siebie: medytacji, pielęgnacji skóry i zdrowego śniadania. "Dobre samopoczucie wewnętrzne przekłada się na to, jak wyglądam," mówi. Jako modelka współpracująca z Onlyglance.com wie, jak ważne jest utrzymanie energii i pewności siebie...',
          gb: 'Mia starts her day with self-care: meditation, skincare, and a healthy breakfast. "Feeling good inside reflects on the outside," she says. As a model with Onlyglance.com, she knows the importance of staying energized and confident...',
          ru: 'Мия начинает свой день с заботы о себе: медитация, уход за кожей и полезный завтрак. "Когда ты чувствуешь себя хорошо внутри, это отражается и снаружи," говорит она. Как модель, сотрудничающая с Onlyglance.com, Мия знает, как важно поддерживать энергию и уверенность...'
        },
        content: {
          pl: `<p><strong>Poranek Mii:</strong></p><p>Mia zaczyna dzień od dbania o siebie: medytacji, pielęgnacji skóry i zdrowego śniadania. "Dobre samopoczucie wewnętrzne przekłada się na to, jak wyglądam," mówi. Jako modelka współpracująca z <strong>Onlyglance.com</strong> wie, jak ważne jest utrzymanie energii i pewności siebie.</p><p><strong>Czas na Sesję:</strong></p><p>Późnym rankiem Mia pojawia się w naszym studiu na tematyczną sesję zdjęciową. Atmosfera jest przyjazna, ale profesjonalna. Nasza fotografka dba, by wizja Mii ożyła, pomagając jej w pozach i oświetleniu. "Nigdy wcześniej nie czułam się tak komfortowo przed obiektywem," mówi Mia.</p><p><strong>Tworzenie Treści:</strong></p><p>Po sesji Mia współpracuje ze swoim menedżerem, planując posty i angażując swoją publiczność. Dzięki nam wie, kiedy i jak skutecznie komunikować się z fanami.</p><p><strong>Relaks Wieczorny:</strong></p><p>Dzień Mii kończy się wdzięcznością i refleksją. Dzięki <strong>Onlyglance.com</strong> udaje jej się zrównoważyć kreatywność i wolność finansową.</p><p>Ciekawi Cię, jak mogłoby wyglądać Twoje życie jako modelka OnlyFans? Zostaw nam szczegóły, a my zajmiemy się resztą. Skontaktuj się z nami już dziś, aby dowiedzieć się więcej.</p>`,
          gb: `<p><strong>Mia’s Morning:</strong></p><p>Mia starts her day with self-care: meditation, skincare, and a healthy breakfast. "Feeling good inside reflects on the outside," she says. As a model with <strong>Onlyglance.com</strong>, she knows the importance of staying energized and confident.</p><p><strong>Photoshoot Time:</strong></p><p>By late morning, Mia arrives at our studio for a themed photoshoot. The vibe is fun yet professional. Our photographer ensures Mia’s vision comes to life, guiding her on poses and lighting to create standout content. "I’ve never felt more comfortable in front of a camera," Mia shares.</p><p><strong>Content Creation:</strong></p><p>After the shoot, Mia collaborates with her manager to schedule posts and engage her audience. With our help, she knows when and how to connect with her fans, keeping them engaged and loyal.</p><p><strong>The Evening Wind-Down:</strong></p><p>Mia’s day ends with gratitude and reflection. Thanks to <strong>Onlyglance.com</strong>, she balances creativity and financial freedom.</p><p>Curious about what life could look like as an OnlyFans model? Let us handle the details while you focus on shining. Contact us today to learn more.</p>`,
          ru: `<p><strong>Утро Мии:</strong></p><p>Мия начинает свой день с заботы о себе: медитация, уход за кожей и полезный завтрак. "Когда ты чувствуешь себя хорошо внутри, это отражается и снаружи," говорит она. Как модель, сотрудничающая с <strong>Onlyglance.com</strong>, Мия знает, как важно поддерживать энергию и уверенность.</p><p><strong>Время фотосессии:</strong></p><p>Поздним утром Мия приходит в нашу студию для тематической фотосессии. Атмосфера — дружелюбная и профессиональная. Наш фотограф помогает воплотить видение Мии, подсказывая позы и работая с освещением. "Я никогда раньше не чувствовала себя так комфортно перед камерой," делится Мия.</p><p><strong>Создание контента:</strong></p><p>После фотосессии Мия работает со своим менеджером над планированием публикаций и взаимодействием с подписчиками. Благодаря нашей поддержке, она знает, как и когда лучше всего общаться с фанатами.</p><p><strong>Вечерняя расслабленность:</strong></p><p>День Мии заканчивается благодарностью и размышлениями. Благодаря <strong>Onlyglance.com</strong> ей удаётся балансировать между творчеством и финансовой свободой.</p><p><strong>Призыв к действию:</strong></p><p>Интересно, как может выглядеть ваша жизнь в роли модели OnlyFans? Мы берём на себя все заботы, чтобы вы могли блистать. Свяжитесь с нами сегодня, чтобы узнать больше.</p>`
        }
      },
      {
        id: 1,
        img: img3,
        title: {
          pl: 'Łamiąc Stereotypy: Dlaczego Modeling na OnlyFans to Moc',
          gb: 'Breaking Stereotypes: Why OnlyFans Modeling is Empowering',
          ru: 'Разрушая стереотипы: Почему работа на OnlyFans — это сила'
        },
        description: {
          pl: 'Laura miała dość pracy w korporacji. W wieku 30 lat zrozumiała, że chce czegoś więcej niż długich godzin i braku uznania. Dołączenie do Onlyglance.com to nie tylko zmiana kariery — to zmiana stylu życia...  ',
          gb: 'Laura was tired of the corporate grind. At 30, she realized she wanted more than long hours and minimal recognition. Joining Onlyglance.com wasn’t just a career change; it was a lifestyle shift...  ',
          ru: 'Лаура устала от офисной рутины. В 30 лет она поняла, что хочет большего, чем долгие часы работы и отсутствие признания. Присоединение к Onlyglance.com стало не просто сменой карьеры, а изменением жизни... '
        },
        content: {
          pl: ``,
          gb: `<p><strong>Laura’s Leap of Faith:</strong></p><p>Laura was tired of the corporate grind. At 30, she realized she wanted more than long hours and minimal recognition. Joining <strong>Onlyglance.com</strong> wasn’t just a career change; it was a lifestyle shift.</p><p><strong>The Empowerment Process:</strong></p><ul><li><strong>Overcoming Judgment:</strong> Our team worked with Laura to embrace her individuality and rise above societal stigma.</li><li><strong>Brand Building:</strong> Laura found her niche and developed a unique brand that resonated with her audience.</li><li><strong>Community Support:</strong> Through agency-hosted networking events and workshops, Laura connected with other models and built a strong support system.</li></ul><p><strong>A New Perspective:</strong></p><p>Today, Laura earns double her old salary, but what she cherishes most is the freedom to live authentically. “I’m in control of my life and career. It’s the best feeling in the world.”</p><p>Break free from the stereotypes and embrace a future where you call the shots. Join <strong>Onlyglance.com</strong> and discover how modeling can empower you.</p>`,
          ru: ``
        }
      },
      {
        id: 1,
        img: img4,
        title: {
          pl: '',
          gb: 'From Doubt to Success: How Onlyglance.com Transformed Emma’s Life',
          ru: ''
        },
        description: {
          pl: '',
          gb: 'Emma lacked confidence and feared judgment, but with Onlyglance.com’s support, she built a thriving career. Now, she enjoys financial freedom and newfound self-confidence',
          ru: ''
        },
        content: {
          pl: ``,
          gb: `<p><b>Emma’s Hesitation:</b></p> <p>Emma always admired content creators but never saw herself as one. She worried about judgment, lacked confidence, and didn’t know where to start. After weeks of hesitation, she finally reached out to Onlyglance.com—and it changed everything.</p> <p>The Turning Point:</p> <ul> <li><b>Personalized Coaching</b> – Our team helped Emma discover her strengths and unique appeal.</li> <li><b>Step-by-Step Guidance</b> – She learned how to create engaging content, connect with fans, and grow her audience.</li> <li><b>Full Support System</b> – With our dedicated managers, Emma felt secure and motivated every step of the way.</li> </ul><br /><p>Living Her Dream:</p> <p>Now, Emma earns more than she ever imagined, but beyond the financial success, she’s built confidence and independence. “I never thought I’d be this empowered, but here I am—thriving!”</p> <p>Your story can be next. <b>Join Onlyglance.com today</b> and take control of your future!</p>`,
          ru: ``
        }
      },
      {
        id: 1,
        img: img5,
        title: {
          pl: '',
          gb: 'Beyond the Camera: How Onlyglance.com Supports Its Models',
          ru: ''
        },
        description: {
          pl: '',
          gb: 'Lena thought she had to manage everything alone, but our agency helped her grow effortlessly. With expert guidance, she now focuses on creativity while we handle the rest.',
          ru: ''
        },
        content: {
          pl: ``,
          gb: `<p><b>Lena’s Journey:</b></p> <p>Before joining Onlyglance.com, Lena thought being an OnlyFans model meant handling everything alone. The pressure of content creation, marketing, and managing fans felt overwhelming—until she discovered our agency.</p> <p>How We Helped:</p> <ul> <li><b>Creative Direction</b> – Our team helped Lena develop fresh, engaging content ideas.</li> <li><b>Growth Strategies</b> – With expert marketing, Lena’s audience grew faster than she expected.</li> <li><b>Legal & Financial Support</b> – We guided her through contracts, payments, and privacy protection.</li> </ul><br /><p>A Stress-Free Career:</p> <p>Today, Lena focuses on what she loves—expressing herself creatively—while we handle the rest. “I finally have balance in my life, and I’m making more money than I did in my 9-to-5 job.”</p> <p>Want to focus on content while we handle the business side? <b>Onlyglance.com has your back!</b></p>`,
          ru: ``
        }
      },
      {
        id: 1,
        img: img6,
        title: {
          pl: '',
          gb: 'The Ultimate Work-Life Balance: Anna’s Story',
          ru: ''
        },
        description: {
          pl: '',
          gb: 'Anna wanted financial stability without sacrificing her freedom, and Onlyglance.com made it possible. Now, she earns more while working less and living life on her terms.',
          ru: ''
        },
        content: {
          pl: ``,
          gb: `<p><b>Struggling with Time:</b></p> <p>Anna was tired of juggling multiple jobs just to make ends meet. She wanted financial stability without sacrificing her freedom. That’s when she found Onlyglance.com.</p> <p>The Transformation:</p> <ul> <li><b>Flexible Schedule</b> – Anna learned how to plan content efficiently, allowing her to work fewer hours.</li> <li><b>Higher Earnings</b> – With our expert monetization strategies, she quickly boosted her income.</li> <li><b>Personal Growth</b> – She gained confidence, independence, and a loyal fanbase.</li> </ul> <br /><p>The Freedom to Live:</p> <p>Now, Anna spends more time traveling, focusing on self-care, and enjoying life on her own terms. “This is the first time I truly feel free.”</p> <p>Want to achieve financial freedom and flexibility? <b>Onlyglance.com can help!</b></p>`,
          ru: ``
        }
      }
  ];

  const handlePostClick = (post) => {
    setSelectedPost(post);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPost(null);
  };

  return (
    <div className="container blog-container" id="blog">
      <div className="row">
        {blogPosts.map((post) => (
          <div key={post.id} className="col-md-4 mb-4">
            <div className="card" onClick={() => handlePostClick(post)}>           
              <div className="card-body">
                <div className="card-image-wrapper">
                    <img src={post.img} style={{width: "100%"}} loading="lazy"/>
                </div>
                <h5 className="card-title">{post.title[lang.lang]}</h5>
                <p className="card-text">{post.description[lang.lang]}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedPost?.title[lang.lang]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{__html: selectedPost?.content[lang.lang]}}></div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            {getText('closeButton')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BlogPosts;